import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import _isEmpty from "lodash/isEmpty";
import _isFunction from "lodash/isFunction";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Row, Col, Button, Dropdown, AddEditContactForm } from 'components';
import { showApiError } from 'utils';
import { getContactsList } from 'services';
import { jsx as ___EmotionJSX } from "@emotion/react";

var container = function container(theme) {
  return {
    marginTop: '2em',
    borderTop: "1px solid ".concat(theme.gray150),
    paddingTop: '2em'
  };
};

var headerRow = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '1.4em'
};

var titleStyle = function titleStyle(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '0.6em',
    '& i': {
      fontSize: '1.6rem',
      color: theme.primary
    },
    '& span': {
      fontSize: '1.3rem',
      fontWeight: 600,
      color: theme.gray700,
      textTransform: 'uppercase',
      letterSpacing: '0.04em'
    }
  };
};

var selectRow = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '1em'
};

var orDivider = function orDivider(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '1em',
    margin: '1.6em 0',
    '& hr': {
      flex: 1,
      border: 'none',
      borderTop: "1px solid ".concat(theme.gray150)
    },
    '& span': {
      fontSize: '1.2rem',
      color: theme.gray400,
      fontWeight: 500,
      textTransform: 'uppercase'
    }
  };
};

var CreditContactForm = function CreditContactForm(_ref) {
  var onSubmit = _ref.onSubmit,
      borrowerIdNumber = _ref.borrowerIdNumber;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      contacts = _useState2[0],
      setContacts = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isAdd = _useState4[0],
      setIsAdd = _useState4[1];

  useEffect(function () {
    fetchContacts();
  }, []);

  var fetchContacts = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getContactsLis, _yield$getContactsLis2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getContactsList({
                pageSize: 100,
                idNumber: borrowerIdNumber
              });

            case 2:
              _yield$getContactsLis = _context.sent;
              _yield$getContactsLis2 = _slicedToArray(_yield$getContactsLis, 2);
              res = _yield$getContactsLis2[0];
              err = _yield$getContactsLis2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setContacts(res);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchContacts() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleAddContact = function handleAddContact() {
    setIsAdd(false);
    fetchContacts();
  };

  var handleSubmit = function handleSubmit(_ref3) {
    var values = _ref3.values;
    _isFunction(onSubmit) && onSubmit(values);
  };

  var hasContacts = !_isEmpty(contacts === null || contacts === void 0 ? void 0 : contacts.data);
  return ___EmotionJSX("div", {
    css: container
  }, ___EmotionJSX("div", {
    style: headerRow
  }, ___EmotionJSX("div", {
    css: titleStyle
  }, ___EmotionJSX("i", {
    className: "las la-address-book"
  }), ___EmotionJSX("span", null, "\u041B\u0438\u0446\u0435 \u0437\u0430 \u043A\u043E\u043D\u0442\u0430\u043A\u0442"))), !isAdd && ___EmotionJSX(Form, {
    onSubmit: handleSubmit
  }, ___EmotionJSX("div", {
    style: selectRow
  }, ___EmotionJSX("div", {
    style: {
      flex: 1
    }
  }, ___EmotionJSX(Dropdown, {
    required: true,
    withSearch: true,
    displayKey: "name",
    uniqueKey: "id",
    formId: "contact_person_id",
    label: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043A\u043E\u043D\u0442\u0430\u043A\u0442",
    placeholder: hasContacts ? 'Изберете от списъка...' : 'Няма контакти — добавете нов',
    options: contacts === null || contacts === void 0 ? void 0 : contacts.data,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.id;
    }
  })), ___EmotionJSX("div", {
    style: {
      marginTop: '2.1em'
    }
  }, function (_ref4) {
    var formSubmit = _ref4.onSubmit;
    return ___EmotionJSX(Button, {
      onClick: formSubmit,
      disabled: !hasContacts
    }, "\u041D\u0430\u043F\u0440\u0435\u0434");
  }))), ___EmotionJSX("div", {
    css: orDivider
  }, ___EmotionJSX("hr", null), ___EmotionJSX("span", null, isAdd ? 'Нов контакт' : 'или'), ___EmotionJSX("hr", null)), isAdd ? ___EmotionJSX(React.Fragment, null, ___EmotionJSX(AddEditContactForm, {
    onSubmit: handleAddContact,
    borrowerIdNumber: borrowerIdNumber
  }), ___EmotionJSX(Row, {
    horizontalGap: 8,
    margin: "1em 0 0 0"
  }, ___EmotionJSX(Col, {
    displayFlex: true,
    md: 12,
    justify: "flex-start"
  }, ___EmotionJSX(Button, {
    type: "secondary",
    onClick: function onClick() {
      return setIsAdd(false);
    }
  }, "\u041E\u0442\u043A\u0430\u0437")))) : ___EmotionJSX(Button, {
    type: "secondary",
    onClick: function onClick() {
      return setIsAdd(true);
    },
    fullWidth: true
  }, ___EmotionJSX("i", {
    className: "las la-plus",
    style: {
      marginRight: 6
    }
  }), "\u0414\u043E\u0431\u0430\u0432\u0438 \u043D\u043E\u0432 \u043A\u043E\u043D\u0442\u0430\u043A\u0442"));
};

CreditContactForm.propTypes = {
  onSubmit: PropTypes.func,
  borrowerIdNumber: PropTypes.string
};
export default CreditContactForm;